import { useMemo } from 'react';

import { useProviderAccountsController_getClientIntegrations } from '@/services/hooks';

import { mapIntegrations } from './accountMappers';
import type { ClientIntegrationRow } from './accountTypes';
import { type ProviderConfigError, parsedErrorOrNull } from './errors';

export interface UseClientIntegrationsResult {
    rows: ClientIntegrationRow[];
    isLoading: boolean;
    error: ProviderConfigError | null;
}

export function useClientIntegrations(clientId: number): UseClientIntegrationsResult {
    const query = useProviderAccountsController_getClientIntegrations(clientId, {
        enabled: Number.isInteger(clientId) && clientId > 0,
    });
    const dtos = query.data?.data;
    const rows = useMemo(() => (dtos ? mapIntegrations(dtos) : []), [dtos]);
    const error = useMemo(() => parsedErrorOrNull(query.error), [query.error]);
    return { rows, isLoading: query.isPending, error };
}
